import { Route } from '@angular/router';
import { AuthLayoutComponent } from '@buspro/web/shared';
import { AnonUserGuard } from '@corelabs/ng-auth';
import { LoginComponent } from './login/login.component';
import { SetNewPasswordFormComponent } from './set-new-password-form/set-new-password-form.component';

export const AuthRoutes: Route = {
  path: 'passport',
  canActivate: [AnonUserGuard],
  component: AuthLayoutComponent,
  children: [
    {
      path: 'login',
      component: LoginComponent,
      data: { title: 'Login' },
    },
    {
      path: 'reset-password-request-form',
      data: { title: 'Reset Password' },
      loadComponent: () =>
        import('./reset-password-request-form/reset-password-request-form.component').then(
          (c) => c.ResetPasswordRequestFormComponent,
        ),
    },
    {
      path: 'password-changed',
      component: SetNewPasswordFormComponent,
      data: { title: 'Password changed' },
    },
  ],
};
